/**
 * One-time SurveyJS + survey-core bootstrap. Import this module once, at app
 * start (src/index.tsx), before any <Survey> renders.
 *
 * Order matters for the stylesheets: SurveyJS 3's own structural CSS first,
 * then the FDS token layer + SurveyJS-3 adapter from survey-core (`/styles`
 * is the package's single CSS entry). Brand selection is NOT a CSS import —
 * it is the `data-brand` attribute the host wrapper sets around <Survey>.
 */
import 'survey-core/survey-core.min.css';
// Spanish + French dictionaries (SurveyJS ships them as side-effect imports).
import 'survey-core/i18n/spanish';
import 'survey-core/i18n/french';
import '@latitude-digital/survey-core/styles';

import { Serializer } from 'survey-core';
import { registerUniversalQuestions } from '@latitude-digital/survey-core';
import { registerFDSRenderers } from '@latitude-digital/survey-core/react';

let bootstrapped = false;

/**
 * Properties the shipped survey JSONs author on package types. The Canadian
 * JSONs set `country: "ca"` on the address composite; the app's Google
 * Places attach (helpers/surveyTemplatesAll.ts) reads it back off `jsonObj`.
 */
function registerAppProperties(): void {
  if (!Serializer.findProperty('autocompleteaddress', 'country')) {
    Serializer.addProperty('autocompleteaddress', {
      name: 'country',
      default: 'us',
      category: 'general',
      visibleIndex: 3,
    });
  }
}

export function bootstrapSurveyCore(): void {
  if (bootstrapped) return;
  bootstrapped = true;

  // Control-only renderers for the interactions stock SurveyJS cannot express
  // (VOI cards, email domain suggestions, markdown, ...). Idempotent.
  registerFDSRenderers();

  // Composite question types (firstname, email, phone, autocompleteaddress,
  // fordvoi, lincolnvoi, vehicledrivenmostmake, ...). Never register these a
  // second way — two registrations of one type is not supported.
  registerUniversalQuestions('ford', 'frontend');
  registerUniversalQuestions('lincoln', 'frontend');
  registerAppProperties();
}

bootstrapSurveyCore();
